export type UploadKind = 'athlete-data' | 'athlete-images';

export interface SignedUploadFileRequest {
  kind: UploadKind;
  fileName: string;
  contentType: string;
  sizeBytes: number;
}

export interface SignedUploadRequest {
  files: [SignedUploadFileRequest, SignedUploadFileRequest];
}

function contentType(file: File, fallback: string) {
  return file.type || fallback;
}

export function prepareSignedUploadRequest(csvFile: File, zipFile: File): SignedUploadRequest {
  return {
    files: [
      {
        kind: 'athlete-data',
        fileName: csvFile.name,
        contentType: contentType(csvFile, 'text/csv'),
        sizeBytes: csvFile.size,
      },
      {
        kind: 'athlete-images',
        fileName: zipFile.name,
        contentType: contentType(zipFile, 'application/zip'),
        sizeBytes: zipFile.size,
      },
    ],
  };
}
